







import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../store/edit';

export default Vue.extend({
	name: 'StavPredPujcenim',
	props: {
		storeUri: String,
	},
	computed: {
		...genVuexComputeds(store),
	},
});
